export interface UserSettings {
  name: string;
  email: string;
  timezone: string;
  mentor: { used: number; monthly_limit: number; remaining: number; renews_on: string };
  subscription_status: string;
}

export const MX_TIMEZONES: { value: string; label: string }[] = [
  { value: "America/Mexico_City", label: "México – Centro (CDMX, Guadalajara, Monterrey)" },
  { value: "America/Cancun", label: "México – Quintana Roo (Cancún)" },
  { value: "America/Chihuahua", label: "México – Chihuahua" },
  { value: "America/Mazatlan", label: "México – Pacífico (Sinaloa, Nayarit, BCS)" },
  { value: "America/Hermosillo", label: "México – Sonora" },
  { value: "America/Tijuana", label: "México – Baja California (Tijuana)" },
];

export function allTimezones(): string[] {
  const intl = Intl as unknown as { supportedValuesOf?: (k: string) => string[] };
  const mx = new Set(MX_TIMEZONES.map((t) => t.value));
  return (intl.supportedValuesOf?.("timeZone") ?? []).filter((z) => !mx.has(z));
}
